import {useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import axios from "axios";
import Info from '../../assets/info.png';
import Download from '../../assets/downloadBlue.png'
import Error from '../../assets/error.png';
import Check from '../../assets/check.png';

export const Redirect = () => {

    const {transaction_id} = useParams()
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const authToken = urlParams.get('auth')
    const logo = urlParams.get('logo')
    const decodedLogo = decodeURIComponent(logo);
    const apiUrl = process.env.REACT_APP_API_URL;

    const [showTransactionData, setTransactionData] = useState(undefined)
    const [status, setStatus] = useState(undefined)

    useEffect(() => {
        console.log("status is", status)
    }, [status])

    const getTransactionData = () => {
        let config = {
            method: 'get',
            url: `${apiUrl}/getenachstatus?transaction_id=${transaction_id}`,
            headers: {
                "X-AUTH": authToken
            }
        };
        axios(config).then((res) => {
            const resData = res.data
            if (resData.success === true) {
                setTransactionData(resData)
                resData.status === 'Failed'? setStatus('Failed'): setStatus('Success')
            } else {
                console.log("Error")
            }
        }).catch(e => {
            console.log(e)
        })
    }

    useEffect(() => {
        getTransactionData()
    }, [])

    return (
        <div style={{
            backgroundColor: '#FFFFFF',
            fontFamily: 'Poppins',
            fontSize: '1rem',
            fontWeight: '400'
        }}>
            {status !== undefined &&
                <div className="container" style={{margin: '1rem'}}>
                    <div className='header'>
                        <div className='header-img' style={{width: '12rem', margin: 'auto'}}>
                            <img src={decodedLogo} height="100%"
                                 width="100%"
                                 alt="Lender Logo"/>
                        </div>
                        {status === "Success" && <p style={{wordBreak: 'break-all', textAlign: "center", fontWeight: '700', marginTop: '0', color: '#9D9D9D'}}>Transaction ID: {showTransactionData.transaction_id}</p>}
                    </div>
                    <div className="mid-section-success" style={{
                        textAlign: "center",
                        width: '80%',
                        margin: 'auto',
                        color: status === "Success" ? '#048F42' : '#BF2929',
                        paddingTop: status === 'Success' ? 'none' : '2rem'
                    }}>
                        <span><img src={status === "Success" ? Check : Error} width="50px" height="50px"
                                   style={{maxWidth: "50px", maxHeight: "50px", marginTop: "2%"}}/></span>
                        <p style={{fontWeight: '700'}}>{status === "Success" ? "Thank you!" : "Mandate registration failed!"}</p>
                        <p>{status === "Success" ? "Your request has been initiated successfully!" : "Please fill the details again or select physical NACH option"}</p>
                    </div>

                    <div className="transaction-details-container" style={{marginTop: '1.25rem'}}>
                        <p style={{textDecoration: 'underline', color: '#7D7D7D', textAlign: 'center'}}>Transaction Details</p>

                        <div className="transaction-details" style={{marginTop: '1rem', marginBottom: '1rem', width: '90%', margin: "auto"}}>
                            <hr style={{height: '0', border: '1px solid #E6E6E6',}}/>

                            <div style={{display: 'flex', marginBottom: '-0.8rem'}}>
                                <div style={{marginRight: '2px', color: '#9D9999'}}><p>Merchant <br/> Txn. ID:</p></div>
                                <div style={{marginLeft: 'auto', wordBreak: 'break-all', marginTop: '1rem', color: '#4F4F4F'}}>
                                    <p>{showTransactionData.transaction_id}</p></div>
                            </div>

                            {status === "Success" &&
                                <div style={{display: 'flex', marginBottom: '-0.8rem'}}>
                                    <div style={{marginRight: '2px', color: '#9D9999'}}><p>Transaction ID:</p></div>
                                    <div style={{marginLeft: 'auto', wordBreak: 'break-all', color: '#4F4F4F'}}>
                                        <p>{showTransactionData.tpsl_transaction_id}</p>
                                    </div>
                                </div>
                            }

                            <div style={{display: 'flex', marginBottom: '-0.8rem'}}>
                                <div style={{marginRight: '2px', color: '#9D9999'}}><p>Date:</p></div>
                                <div style={{marginLeft: 'auto', wordBreak: 'break-word', color: '#4F4F4F'}}>
                                    <p>{showTransactionData.txn_timestamp.substring(0, 10)}</p>
                                </div>
                            </div>

                            <div style={{display: 'flex'}}>
                                <div style={{marginRight: '2px', color: '#9D9999'}}><p>Time:</p></div>
                                <div style={{marginLeft: 'auto', wordBreak: 'break-word', color: '#4F4F4F'}}>
                                    <p>{showTransactionData.txn_timestamp.substring(11)}</p>
                                </div>
                            </div>

                            <hr style={{height: '0', border: '1px solid #E6E6E6'}}/>

                        </div>
                    </div>

                    <div className="button-options" style={{width: '90%', margin: "auto"}}>
                        <div style={{display: 'flex'}}>
                            <a href={showTransactionData.signedPdfUrl} style={{margin: "auto", textDecoration: 'none'}}>
                                <button className="download-receipt" style={{
                                    width: '11rem',
                                    height: '2.5rem',
                                    border: "1.5px solid #198BF3",
                                    borderRadius: "1.25rem",
                                    color: "#198BF3",
                                    backgroundColor: '#FFFFFF',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}><img src={Download} width="100%" height="100%" style={{maxWidth: '1.25rem', maxHeight: '1.25rem', marginRight: '0.625rem', color: '#198BF3'}}/>Download Receipt
                                </button>
                            </a>
                        </div>
                        <div style={{display: 'flex', marginTop: '0.5rem'}}>
                            <a href="/done" style={{margin: "auto", textDecoration: 'none'}}>
                                <button className="ok-btn" style={{
                                    width: '11rem',
                                    height: '2.5rem',
                                    border: "1.5px solid #198BF3",
                                    borderRadius: "1.25rem",
                                    color: "#FFFFFF",
                                    backgroundColor: "#198BF3",
                                }}>OK
                                </button>
                            </a>
                        </div>
                        <div style={{color: '#A3A3A3', display: 'flex', alignItems: 'start', marginTop: '0.635rem', justifyContent: 'center'}}>
                            <span style={{marginRight: '0.5rem'}}><img src={Info} width="100%" height="100%" style={{marginBottom: "-0.5%", maxWidth: '1.5rem', maxHeight: '1.5rem', minWidth: '1.5rem', minHeight: '1.5rem', marginTop: '10%'}}/></span >
                            <p style={{marginTop: '0'}}>Your information is secured using industry standard encryption</p>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}
